<template>
	<div class="convention-hall page">
		<van-nav-bar class="nav-bar" fixed placeholder>
			<template #left>
				<img :src="$store.getters.getBaseInfo.ico !== undefined
					? $store.getters.getBaseInfo.ico
					: '/img/null.png'
					" />
			</template>
			<template #right>
				<img @click="$router.push('/Mine')" class="w2" src="/img/home/shuju.png" alt="">
			</template>
		</van-nav-bar>
		<!-- <div class="address-active" @click.stop="address_show=!address_show">{{ chooseActive.name }}
			
		<ul class="address-nav" v-if="address_show">
			<li @click.stop="addgo(val)" :class="chooseActive.name!=val.name||'active'" v-for="(val, key) in addlist" :key="key">
				{{ val.name }}
			</li>
		</ul>
		</div> -->
		<van-pull-refresh pulling-text="새로고침 성공" loosing-text="페이지 새로 고침" loading-text="새로고침 성공"
				success-text="새로고침 성공" border="false" class="list-wrapper" v-model="isLoading" @refresh="onRefresh">
				<div class="movie-item m-flex" @click="profile(v.id)" v-for="(v, k) in datalist" :key="k">
					
					<van-image class="movie-img" round :src="v.img_url">
						<template v-slot:loading>
							<van-loading type="circular" />
						</template>
					</van-image>
					<div class="m-f1 m-md2-l">
						<p>{{ v.xuanfei_name||$t('No information yet') }}</p>
					</div>
				</div>
				<div class="next" v-if="datalist.length>=15" @click="nextList()">
					{{ $t('next') }}
				</div>
			</van-pull-refresh>
		<div class="address">
			<!-- <van-cell-group v-for="(val, key) in addlist" :key="key">
				<van-cell @click="addgo(val)">{{ val.name }}</van-cell>
			</van-cell-group> -->
		</div>
		<div class="convention-item" v-if="false">
			<van-tabs animated sticky line-width="100px" :swipeable="true">
				<van-tab :title="$t('concubine.city')">
					<div class="card">{{ $t("concubine.city_tip") }}</div>
					<div class="address">
						<van-cell-group v-for="(val, key) in addlist" :key="key">
							<van-cell @click="addgo(val)">{{ val.name }}</van-cell>
						</van-cell-group>
						<!-- <van-row type="flex" justify="" gutter="65" v-for="(val, key) in addlist" :key="key">
							<van-col span="" offset="" @click="addgo(v)" v-for="(v, k) in val" :key="k">{{ v.name }}</van-col>
						</van-row> -->
					</div>
				</van-tab>
				<van-tab :title="$t('concubine.price')">
					<div class="card">{{ $t("concubine.city_tip") }}</div>
					<div class="rig-box">
						<p class="rig-title">{{ $t("concubine.pri_resource") }}</p>
						<p class="rig-content">{{ $t("concubine.pri_obj") }}</p>
						<p class="rig-title">{{ $t("concubine.pri_service") }}</p>
						<p class="rig-content">{{ $t("concubine.pric_service_one") }}</p>
						<p class="rig-content">{{ $t("concubine.pric_service_two") }}</p>
					</div>
				</van-tab>
			</van-tabs>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			addlist: [],
			chooseActive:{},
			address_show:false,
			vod_name: '',
			isLoading: false,
			datalist:[],
			choose_page:1
		};
	},
	methods: {
		nextList(){
			this.choose_page+=1
			this.getxuanfeilist()
		},
		onRefresh() {
			setTimeout(() => {
				this.$toast(this.$t("reservation.refresh"));
				this.isLoading = false;
			}, 500);
		},
		getxuanfeilist() {
			this.$http({
				method: 'get',
				url: 'xuanfeilist',
				data: { page:this.choose_page }
			}).then(res => {
			console.log(res.data);
				if(res.data.length>0){
					this.datalist.push(...res.data);
				}else{
					this.page-=1
				}
			});
		},
		profile(id) {
                        this.$router.push({ path: '/Profile?id=' + id + '&name=' + this.chooseActive.vod_name + '&adsid=' + this.chooseActive.id });
		},
		addgo(data) {
			if (!localStorage.getItem('token')) {
				this.$router.push({ path: '/Login' });
			} else {
				// this.$router.push({ path: '/list?id=' + data.id + '&name=' + data.name });
				this.chooseActive=data
				this.address_show=false
				this.getxuanfeilist()
			}
		},
		getAddress() {
			this.$http({
				method: 'get',
				url: 'address_list'
			}).then(res => {
				this.addlist = res.data;
				this.chooseActive=res.data[0]
				this.getxuanfeilist()
				console.log(res.data)
			});
		}
	},
	created() {
		this.getAddress();
	}
};
</script>

<style lang="less" scoped>
@import "@/assets/css/base.less";
.next{
	padding: @pd1;
	margin: @md1;
	color: @theme2;
	text-align: center;
}
.movie-item {
	position: relative;
	margin: @md1;
	padding: @pd1;
	background-color: @theme1;
	border: 1px solid @theme2;
	border-radius: @br1;
	color: @white;
}

.movie-img {
	width: 25vw;
	height: 25vw;

	/deep/ img {
		padding: 0;
	}
}
.address-active{
	padding: @pd1;
	position: relative;
	color: @white;
	text-align: center;
}
.address-nav{
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	z-index: 999;
	color: @white;
	max-height: 40vh;
	overflow-y: scroll;
	padding: @pd1;
	text-align: left;
	&>li{
		background-color: @theme1;
		padding: @pd1;
		border: 1px solid transparent;
		&.active{
			color: @theme2;
			border-color:@theme2;
		}
	}
}
/deep/ .van-tabs__nav {
	background: @theme1;

	.van-tab {
		color: @grey;
	}

	.van-tab--active {
		color: @theme2;
	}

	.van-tabs__line {
		background-color: @theme2;
	}
}

/deep/ .van-cell-group,
/deep/ .van-cell {
	margin: .5em 0;
	background-color: transparent;

	&.van-cell-group {
		background-color: @theme1;
		border: 1px solid @theme2;
		border-radius: @br1;
	}

	.van-cell__value--alone {
		color: @theme2;
	}
}

.page {
	position: absolute !important;
	top: 0;
	left: 0;
	right: 0;
	background-color: @page_bg;
}

.nav-bar {
	height: 100px;
}

.van-nav-bar {
	line-height: 50px;
}

::v-deep .van-nav-bar__title {
	max-width: 60%;
	margin: 0 auto;
	color: #ffffff;
	font-size: 35px;
}

::v-deep .van-nav-bar__content {
	height: 100px;
}

.van-sidebar {
	width: 180px;
}

// /deep/ .van-col{
// padding: 30px 0px;
// }
.convention-hall {
	display: flex;
	flex-direction: column;
	bottom: 20px;
	height: max-content;
}

::v-deep .van-tab {
	font-size: 30px;
	line-height: 100px;
	font-weight: bold;
}

::v-deep .van-tabs--line .van-tabs__wrap {
	height: 100px;
}

::v-deep .van-tabs__wrap--scrollable .van-tab {
	padding: 0 23px;
}

.card {
	background: linear-gradient(@btn1, @btn2);
	padding: 0.625rem;
	width: 95%;
	color: @black;
	font-size: 0.8125rem;
	margin: 0.625rem auto;
	border-radius: 0.375rem;
}

::v-deep .van-row--flex {
	height: 80px;
	line-height: 80px;
}

/deep/ .van-cell {
	padding: 30px 22px;
	font-size: 30px;
	line-height: 30px;
}

.rig-box {
	width: 95%;
	margin: 0.625rem auto;
}

.rig-title {
	color: @theme2;
	font-size: 1.125rem;
}

.rig-content {
	font-size: 20px;
	// margin-top: 10px;
	color: @grey;
}

.address {
	width: 94%;
	margin: 0 auto;
	margin-bottom: 110px;
}
</style>
